export default __webpack_public_path__ + "cbe0ae49c52c920fd563b5f3633b5553.woff2";